import styled from "styled-components";
import LoadingBox from "../../../shared/LoadingBox";
import FlyoutModal, { ModalProps } from "@teamscheme/flyout-modal";
import { UpgradeModalContent } from "./UpgradeModalContent";

const LoadingWrapper = styled.div`
  height: ${8 * 40}px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Loading = () => (
  <>
    <LoadingWrapper>
      <LoadingBox />
    </LoadingWrapper>
  </>
);

interface UpgradeContractModalProps
  extends Omit<ModalProps, "title" | "children"> {}

export default styled(function UpgradeContractModal({
  isOpen,
  onClose,
  ...props
}: UpgradeContractModalProps) {
  return (
    <FlyoutModal isOpen={isOpen} onClose={onClose} {...props}>
      {isOpen ? <UpgradeModalContent closeModal={onClose} /> : <Loading />}
    </FlyoutModal>
  );
})`
  width: initial;
  flex: 0 1 ${8 * 70}px;
`;
